import { MouseEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles, Menu, MenuItem } from '@material-ui/core'

import { Button, Flex } from 'app/ui'

import { language } from 'app/utils/app/language'
import { assets } from 'app/utils/constants'
import { joinStyles } from 'app/utils/theme'

import { Locale } from 'app/types/app/language'

const useStyles = makeStyles((theme) => ({
    name: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'unset',
        },
    },

    nameLogin: {
        display: 'unset',
    },

    flagBox: {
        width: '50px',
        paddingRight: '5px',
    },

    flag: {
        height: '20px',
        maxWidth: '100%',
    },
}))

type ChooseLanguageProperties = {
    isLogin?: boolean
}

export const ChooseLanguage = ({
    isLogin,
}: Readonly<ChooseLanguageProperties>): JSX.Element => {
    const classes = useStyles()
    const { i18n } = useTranslation()

    const [anchorElement, setAnchorElement] = useState(null)

    const isOpen = Boolean(anchorElement)

    /** Open the language selection. */
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorElement(event.currentTarget)
    }

    /** Close the language selection. */
    const handleClose = () => {
        setAnchorElement(null)
    }

    /** Change the language for the new selected. */
    const handleChangeLanguage = (locale: Locale) => {
        i18n.changeLanguage(locale)
    }

    return (
        <>
            <Button
                variant='outlined'
                color={isLogin ? undefined : 'secondary'}
                icon={
                    <img
                        className={classes.flag}
                        src={assets.flags[i18n.language]}
                        alt={i18n.language}
                    />
                }
                onClick={handleClick}
            >
                <div
                    className={joinStyles(
                        classes.name,
                        isLogin && classes.nameLogin,
                    )}
                >
                    {language[i18n.language]}
                </div>
            </Button>

            <Menu
                anchorEl={anchorElement}
                open={isOpen}
                onClose={handleClose}
            >
                {Locale.options.map((locale) => (
                    <MenuItem
                        key={locale}
                        onClick={() => {
                            handleClose()
                            handleChangeLanguage(locale)
                        }}
                    >
                        <Flex className={classes.flagBox}>
                            <img
                                className={classes.flag}
                                src={assets.flags[locale]}
                                alt={language[locale]}
                            />
                        </Flex>

                        {language[locale]}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}
